import { render, staticRenderFns } from "./regionalflow.vue?vue&type=template&id=2e0b60b2&scoped=true&"
import script from "./regionalflow.vue?vue&type=script&lang=js&"
export * from "./regionalflow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/components.scss?vue&type=style&index=0&id=2e0b60b2&lang=scss&scoped=true&"
import style1 from "./regionalflow.vue?vue&type=style&index=1&id=2e0b60b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b60b2",
  null
  
)

export default component.exports